<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="file_023">basic techniques</a></h2><a id="file_023">
</a><h3 class="h3"><a id="file_023"></a><a id="file_023a">1. Needling</a></h3><a id="file_023a">
<p class="noindent">Hold the felting needle in your hand like a pen or pencil. Poke the needle straight into the wool <strong>(A)</strong>. The needle doesn’t need to penetrate the surface more than ¼″ (6 mm) because the barbs are only on the tip of the needle. Lift and poke with the needle, enough to secure the fibers into place. The more you poke, the tighter the fibers get <strong>(B)</strong>.</p>
<p class="image"><img alt="Image" src="images/f0010-01.jpg"/></p>
<p class="image"><img alt="Image" src="images/f0010-02.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_023.vue?57dc5ed3